class NerCountdown extends HTMLElement {
  connectedCallback() {
    const d = parseInt(this.dataset.duration || '300', 10);
    let end = parseInt(sessionStorage.getItem('nerCartEnd') || '0', 10);
    const now = Date.now();
    if (!end || end < now) { end = now + d * 1000; try { sessionStorage.setItem('nerCartEnd', end); } catch (e) {} }
    const tick = () => {
      let r = Math.max(0, Math.round((end - Date.now()) / 1000));
      this.textContent = String(Math.floor(r / 60)).padStart(2, '0') + ':' + String(r % 60).padStart(2, '0');
      if (r <= 0) { end = Date.now() + d * 1000; try { sessionStorage.setItem('nerCartEnd', end); } catch (e) {} }
    };
    tick(); this._t = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
}
if (!customElements.get('ner-countdown')) customElements.define('ner-countdown', NerCountdown);

// Accordéons Dawn (details/summary) : ouverture / fermeture animées
document.addEventListener('click', function (e) {
  const summary = e.target.closest('.accordion details > summary');
  if (!summary) return;
  const details = summary.parentElement;
  const content = details.querySelector('.accordion__content');
  if (!content || details.dataset.animating) return;
  e.preventDefault();
  details.dataset.animating = '1';
  const cs = getComputedStyle(content);
  const full = { h: content.scrollHeight + 'px', pt: cs.paddingTop, pb: cs.paddingBottom, mt: cs.marginTop, mb: cs.marginBottom };
  const zero = { h: '0px', pt: '0px', pb: '0px', mt: '0px', mb: '0px' };
  const set = (v, withTransition) => {
    content.style.transition = withTransition ? 'height .3s ease, padding .3s ease, margin .3s ease, opacity .3s ease' : 'none';
    content.style.overflow = 'hidden'; content.style.height = v.h; content.style.paddingTop = v.pt; content.style.paddingBottom = v.pb;
    content.style.marginTop = v.mt; content.style.marginBottom = v.mb; content.style.opacity = v === zero ? '0' : '1';
  };
  if (details.open) {
    set(full, false); void content.offsetHeight; set(zero, true);
    setTimeout(() => { details.open = false; content.style.cssText = ''; delete details.dataset.animating; }, 310);
  } else {
    details.open = true; set(zero, false); void content.offsetHeight;
    full.h = content.scrollHeight + 'px'; set(full, true);
    setTimeout(() => { content.style.cssText = ''; delete details.dataset.animating; }, 320);
  }
});

// Bouton « remonter en haut » (mobile)
(function () {
  const btn = document.querySelector('.ner-top');
  if (!btn) return;
  const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 500);
  window.addEventListener('scroll', toggle, { passive: true }); toggle();
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
})();

// Vidéos galerie : autoplay muet en boucle, sans contrôles ; Dawn appelle pauseAllMedia() à chaque changement de slide → on relance la slide active
(function () {
  const vids = () => document.querySelectorAll('.product__media-list .ner-autoplay video');
  const prep = (v) => { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); };
  const playActive = () => {
    vids().forEach((v) => {
      prep(v);
      const slide = v.closest('.product__media-item');
      const r = v.getBoundingClientRect();
      const visible = r.width > 0 && r.right > 0 && r.left < innerWidth && r.bottom > 0 && r.top < innerHeight;
      const show = (slide && slide.classList.contains('is-active')) || visible;
      // Chrome ne peint pas une vidéo lancée pendant que sa slide était en display:none → load() quand elle réapparaît
      if (show && v.dataset.nerShown !== '1') {
        // preload="none" : il faut charger, puis attendre canplay avant de lancer (sinon play() est rejeté)
        v.dataset.nerShown = '1';
        v.preload = 'auto';
        v.load();
        v.addEventListener('canplay', function () { v.play().catch(function () {}); }, { once: true });
      }
      if (!show) v.dataset.nerShown = '0';
      if (show) { v.play().catch(function () {}); } else { v.pause(); }
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    playActive();
    const orig = window.pauseAllMedia;
    if (typeof orig === 'function') {
      window.pauseAllMedia = function () { orig.apply(this, arguments); setTimeout(playActive, 80); setTimeout(playActive, 700); };
    }
    const io = new IntersectionObserver(() => playActive(), { threshold: [0, 0.4, 1] });
    vids().forEach((v) => io.observe(v));
  });
})();
